<template>
    <div class="footer-socials">
        <span class="footer-socials__title" v-html="$t('Footer.follow_us')"></span>
        <a :href="$t('TotemSocials.facebook_url')" class="footer-socials__link" target="_blank"><span class="icon-facebook1"></span></a>
        <a :href="$t('TotemSocials.linkedin_url')" class="footer-socials__link" target="_blank"><span class="icon-linkedin"></span></a>
        <a :href="$t('TotemSocials.instagram_url')" class="footer-socials__link" target="_blank" ><span class="icon-instagram"></span></a>
    </div>
</template>

<script>
    export default {
        name: 'footer-socials'
    }
</script>

<style lang="scss" scoped>
    [class^="icon-"], [class*=" icon-"] {
        font-size: 1.6rem;
        color: $eerie_black;
        background: $white;
        border-radius: 50%;
        padding: 9px;
        margin: 0;
    }
</style>

<style lang="scss" scoped>
    .footer-socials {
        margin-bottom: 15px;

        &__title {
            font-family: Nunito-ExtraBold, sans-serif;
            font-size: 1.6rem;
            display: block;
            margin: 0 0 20px;
        }

        &__link {
            margin-right: 10px;
            padding: 8px 0 4px 0;
            border-radius: 100%;
        }

        .icon-facebook:before {
            color: $eerie_black;
        }
    }
</style>
